import {
  Button,
  Modal,
  ModalHeader,
  Icon,
  ModalBody,
  FormGroup,
  Label,
  Input,
  Row,
  Col,
  Alert,
} from '@polichat/flamboyant';
import { useCallback, useState } from 'react';
import { Controller } from 'react-hook-form';
import { FormFeedback } from 'reactstrap';
import { CustomModalHeader } from 'src/components/tools/channels/CertificationWabaByPoli/DeleteChannelBsp/styles';
import { useChannelCustomerService } from './useChannelCustomerService';
import { toast } from 'react-toastify';
import history from 'src/services/history';
import { useLocalForm } from './useLocalForm';
import { useGlotaT } from 'src/hooks/useGlotaTranslation';

export interface DeleteChannelProps {
  channel_id: number;
  customer_id: number;
  channel_name: string;
}

export function DeleteChannelModal(props: DeleteChannelProps) {
  const deleteChannel = useGlotaT('spa.tools.deleteChannel');
  const deleteChannelModalTitle = useGlotaT('spa.certification.deleteChannelModalTitle');
  const deleteChannelModalWarning = useGlotaT('spa.certification.deleteChannelModalWarning');
  const deleteChannelModalConfirm = useGlotaT('spa.certification.deleteChannelModalConfirm');
  const deleteChannelModalButton = useGlotaT('spa.certification.deleteChannelModalButton');
  const channelDeletedSuccess = useGlotaT('spa.toasts.channels.deletedSuccess');
  const channelDeleteError = useGlotaT('spa.toasts.channels.deleteChannelError');

  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleIsModalOpen = useCallback(() => {
    setIsModalOpen((prev) => !prev);
  }, []);

  const form = useLocalForm({ name: props.channel_name });

  const service = useChannelCustomerService({
    channel_id: props.channel_id,
    customer_id: props.customer_id,
  });

  function handleSuccess() {
    toast.success(channelDeletedSuccess);
    history.push('/tools/channels/list');
  }

  function handleError() {
    form.reset({ name: '' });
    toast.error(channelDeleteError);
  }
  function handleSubmit() {
    service.remove(handleSuccess, handleError);
  }

  const confirmText = deleteChannelModalConfirm.replace(':channelName', props.channel_name);

  return (
    <>
      <Button color="danger" onClick={handleIsModalOpen}>
        {deleteChannel}
      </Button>

      <Modal
        isOpen={isModalOpen}
        toggle={handleIsModalOpen}
        size="lg"
        className="modal-dialog-scrollable"
      >
        <CustomModalHeader>
          <Icon icon="poli-icon pi-delete-fill" color="var(--danger)" />
          {deleteChannelModalTitle}
        </CustomModalHeader>
        <ModalBody>
          <Alert color="danger">
            {deleteChannelModalWarning}
          </Alert>

          <form id="delete_channel" onSubmit={form.handleSubmit(handleSubmit)}>
            <Row>
              <Col>
                <FormGroup>
                  <Controller
                    control={form.control}
                    name="name"
                    render={({ field, fieldState }) => (
                      <>
                        <Label for="channel_name">
                          {confirmText}
                        </Label>
                        <Input
                          id="channel_name"
                          type="text"
                          value={field.value}
                          onChange={field.onChange}
                          onBlur={field.onBlur}
                          invalid={!!fieldState.error}
                        />
                        <FormFeedback>{fieldState.error?.message}</FormFeedback>
                      </>
                    )}
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col
                sm={{
                  offset: 3,
                  size: 'auto',
                }}
              >
                <Button
                  type="submit"
                  form="delete_channel"
                  color="danger"
                  disabled={!form.watchedValue.name || service.loading}
                >
                  {deleteChannelModalButton}
                </Button>
              </Col>
            </Row>
          </form>
        </ModalBody>
      </Modal>
    </>
  );
}
